import base64ToBlob from "../../../../utils/Base64ToBlob";
import { createSideUpdater } from "../../utils/createSideUpdater";

const useEditorImageApi = ({
  requestPost,
  uiContext,
  pengecekanBerangkatData,
  setPengecekanBerangkatData,
  pengecekanKembaliData,
  setPengecekanKembaliData,
  pengecekanBerangkatDetilData,
  setPengecekanBerangkatDetilData,
  pengecekanKembaliDetilData,
  setPengecekanKembaliDetilData,
  saveDetilMany
}) => {
  // update the data / the detil rows of one side ("berangkat" or "kembali")
  const updatePengecekanData = createSideUpdater({
    berangkat: pengecekanBerangkatData,
    setBerangkat: setPengecekanBerangkatData,
    kembali: pengecekanKembaliData,
    setKembali: setPengecekanKembaliData,
  });
  const updateDetilList = createSideUpdater({
    berangkat: pengecekanBerangkatDetilData,
    setBerangkat: setPengecekanBerangkatDetilData,
    kembali: pengecekanKembaliDetilData,
    setKembali: setPengecekanKembaliDetilData,
  });

  // The markings of a photo card keep the url of the photo they were made on: when the photo is replaced they
  // are moved to the new one. Saved markings are saved again, staged ones (no id yet) only change locally.
  const moveMarkingsToNewGambar = ({ type, field, gambar }) => {
    const detilList =
      type === "berangkat"
        ? pengecekanBerangkatDetilData
        : pengecekanKembaliDetilData;
    const markings = detilList.filter((detil) => detil.label_grup === field);
    if (markings.length === 0) return;

    updateDetilList(type, (list) =>
      list.map((detil) =>
        detil.label_grup === field && !detil.id ? { ...detil, gambar } : detil
      )
    );

    const saved = markings.filter((detil) => detil.id);
    if (saved.length > 0) {
      saveDetilMany({
        type,
        labelGrup: field,
        pengecekanDetilData: saved.map((detil) => ({ ...detil, gambar })),
      });
    }
  };

  // API call
  const savePengecekanBase64Image = async ({ type, field, base64Image }) => {
    const pengecekanData =
      type === "berangkat" ? pengecekanBerangkatData : pengecekanKembaliData;

    const blob = base64ToBlob(base64Image);
    const file = new File([blob], "photo.jpg", { type: "image/jpeg" });
    const formData = new FormData();
    formData.append(field, file);
    formData.append("id", pengecekanData.id);
    // // if (type === "berangkat") {
    // // } else {
    // // formData.append("pengecekan_mobil_id", kembaliData.id);
    // // }
    // // if (id && id > 0) formData.append("id", id);
    requestPost({
      fullUrl: `/api/pemakaian/pengecekanmobil/update`,
      formBody: formData,
      isForm: true,
      onError: ({ message, data }) => {
        uiContext.showErrorMsg("Error", message);
      },
      onSuccess: ({ data, message }) => {
        uiContext.showSuccessMsg("Success", message);
        // reload front end data
        updatePengecekanData(type, (current) => ({
          ...current,
          [field]: `${data[field]}?serial=${Math.random()}`,
        }));
        moveMarkingsToNewGambar({ type, field, gambar: data[field] });
      },
    });
  };

  return {
    savePengecekanBase64Image
  };
};

export default useEditorImageApi;
